import styled from "styled-components";

import { AI_CONCIERGE_FONT_FAMILY } from "@/commands/AIConcierge/assistantWrapper.style";

export const AssistantCommentWrapper = styled.div`
  position: fixed;
  z-index: 3;
  left: 50%;
  top: 45%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const ChoicesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  width: calc(100dvw - 384px);
  gap: 16px;
`;

export const Choice = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 120px;
  background: rgba(38, 93, 222, 0.9);
  border: 8px solid #fff;
  color: #fff;
  font-family: ${AI_CONCIERGE_FONT_FAMILY};
  font-size: 48px !important;
  font-weight: 700;
  white-space: pre-line;
  border-radius: 24px;
  cursor: pointer;
`;

export const RecommendsBackground = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100dvw - 384px);
  background: linear-gradient(to right, #b8ffc1, #aca7fe);
  border-radius: 16px;
  padding: 8px;
`;

export const RecommendsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #fff;
  padding: 32px 128px;
`;

export const Recommend = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1;
  color: #000;
  font-family: ${AI_CONCIERGE_FONT_FAMILY};
  font-size: 36px !important;
  font-weight: 700;
  white-space: pre-line;
  cursor: pointer;
  padding: 0 32px;
  width: 95%;
  min-height: 200px;
  &:not(:last-child) {
    border-bottom: 4px solid #8b8c8e;
  }
  text-align: center;
`;

export const RecommendLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  flex: 1;
  color: #000;
  font-family: ${AI_CONCIERGE_FONT_FAMILY};
  font-size: 36px !important;
  font-weight: 700;
  white-space: pre-line;
  cursor: pointer;
  padding: 32px;
  width: 95%;
  min-height: 200px;
  box-sizing: border-box;
  &:not(:last-child) {
    border-bottom: 4px solid #8b8c8e;
  }
  text-align: left;
`;
